import { render, staticRenderFns } from "./VFormCard.vue?vue&type=template&id=84ac7aca&"
import script from "./VFormCard.vue?vue&type=script&lang=js&"
export * from "./VFormCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports